import { CustomDomainsApi, CustomDomainType } from '@va/shared/api/custom-domains';
import { useMemo } from 'react';

export const useListCompanyDomains = ({
  companyId,
  domainType,
}: {
  companyId: string;
  domainType: CustomDomainType;
}) => {
  const listCustomDomainReq = CustomDomainsApi.useListCompanyDomainsByType(
    companyId
      ? {
          companyId: companyId,
          type: domainType,
        }
      : null,
  );

  const activeDomain = useMemo(() => listCustomDomainReq.data?.active, [listCustomDomainReq.data?.active]);
  const pendingDomain = useMemo(() => listCustomDomainReq.data?.pending, [listCustomDomainReq.data?.pending]);
  const inactiveDomains = useMemo(() => listCustomDomainReq.data?.inactive, [listCustomDomainReq.data?.inactive]);

  return {
    activeDomain,
    pendingDomain,
    inactiveDomains,
    mutate: listCustomDomainReq.mutate,
    isLoading: listCustomDomainReq.isLoading,
    isValidating: listCustomDomainReq.isValidating,
  };
};
